import React from "react";

export const MESSAGES = {
  GENERAL: {
    success: 'Success!'
  },
  LOGIN: {
    'INVALID_USERNAME_PASSWORD_ERROR': 'Sorry, we were not able to find a user with that username and password.',
    'INVALID_ACCOUNT_LOGGED_IN_ERROR': 'An error occurred while trying to log you in. Please contact your school administrator.',
    'GENERAL_API_ERROR': 'An error occurred connecting to the API while trying to log you in. Please refresh and try again.'
  },
  FORGOT_PASSWORD: {
    success: <>If you have an active TES account, please check your email for further instructions. If you don't have an account, please <a href='/#'>contact support</a></>
  },
  RESET_PASSWORD: {
    tokenSuccess: 'Success! Your token is valid. Please enter your new password.',
    tokenFailure: 'Sorry, your change password token was not recognized. Please contact your school administrator.',
    resetPasswordSuccess: 'Success! Your password has been changed.',
    resetPasswordError: 'An error occurred connecting to the API'
  },
  SCHOOLS: {
    success: 'Success! Selected schools have been updated.',
    error: 'An error occurred when updating your school',
    addSchoolSuccess: 'Success! The school has been added to the current district.',
    addSchoolApiError: 'An error occurred connecting to the API while trying to add the school.',
    fetchSchoolsError: 'An error occurred connecting to the API while retrieving the list of schools',
    fileStatusesErrors: 'An error occurred connecting to the API while retrieving the school file status list.'
  },
  DISTRICTS: {
    addSuccess: 'District has been added!',
    updateSuccess: 'District has been updated!',
    error: 'API error: District Name already exists, or External ID is not valid'
  },
  USERS: {
    fetchUsersError: 'An error occurred connecting to the API',
    sendInviteSuccess: 'An invite has been successfully sent to ',
    sendInviteError: 'An error occurred sending the invite',
    changePasswordSuccess: 'Success! Your password has been changed.',
    saveUserProfileErrors: 'An error occurred connecting to the API when saving the user profile',
    sendResetPasswordError: 'An error occurred connecting to the API when trying to send the reset password email',
    saveUserProfileSuccess: "'s profile has been updated.",
    changePasswordError: 'An error occurred connecting to the API when trying to change your password.',
    createUserErrors: 'An error occurred connecting to the API when creating the new user.',
    createUserSuccess: 'Success! The user has been created!',
    sendResetPasswordSuccess: 'has been sent an email with instructions for resetting their password.',
    savePermissionsSuccess: 'Success! The users permissions have been saved.',
    acceptTermsError: 'An error occurred connecting to the API when trying to accept the terms and conditions.',
    superUserPermissions: 'As a super-user, you have Administrator permission for every district.',
    noUserPermissions: 'This user does not have any permissions assigned to them'
  },
  UPLOADS: {
    deleteUploadedFileSucceeded: 'Success! The school file has been deleted.',
    deleteUploadedFileApiErrors: 'An error occurred connecting to the API when trying to delete the school file.',
    getUploadedFileApiErrors: 'An error occurred connecting to the API when trying to download the selected file.',
    filesUploadSuccess: 'Success! Thank you for submitting your data to the University of California Transcript Evaluation Service, your data has been uploaded and is now in queue to be processed. You will receive status notification within the next 24-48 hours. Thank you for your participation.'
  },
  GENERIC_TABLE: {
    noDataAvailable: 'No data available in table',
    noResultsFound: 'No matching records found'
  },
  REPORTS: {
    noReportsPreliminary: "Once your admin uploads data, reports will be available later. In the meantime,",
    noReportsFinal: "Your schools have not been evaluated by UC yet. We'll notify you as your schools complete evaluations, so you know to come back.",
  },
  TOOLTIPS: {
    MY_DATA: {
      pending: 'A school will display in this category if no files have been submitted through the file upload page or a file is still processing.',
      below_quality: 'A school will display in this category once all files have completed processing, but the data quality is below the data quality threshold. View the Data Verification Report to see more details about the data quality.',
      preliminary: 'A school will display in this category once all files have completed processing and preliminary reports are available.',
      final: 'A school will display in this category once all files have completed processing and have been manually evaluated.'
    }
  }
};

//subnavigation for my reports section
export const menuItems = [
  { label: 'Preliminary', name: 'preliminaryReports', enabled: true},
  { label: 'Final', name: 'finalReports', enabled: true},
  { label: 'Historical', name: 'historicalReports', enabled: true}
];

export const manageSchoolsItems = [
  { label: 'District Info', name: 'district-info', enabled: true},
  { label: 'Schools', name: 'schools', enabled: true}
];

export const uploadDataItems = [
  {label: 'TES Excel Template', name: 'xls-template', enabled: true},
  {label: 'Flat File', name: 'flat-file', enabled: false}
];

export const API_URL = 'https://compass-wsd.ucop.edu/CustomerSiteWS2-0.0.1-SNAPSHOT/services/';

export const API_ENDPOINTS = {
  GET_USERS: 'manageUser/getUserManagedList',
  ADD_DISTRICT: 'district/addNewDistrict',
  UPDATE_DISTRICT: 'district/updateDistrict',
  GET_DISTRICTS: 'district/getDistrictList',
  GET_USER_PROFILE: 'manageUser/buildUserProfile',
  UPDATE_USER_PROFILE: 'manageUser/updateProfile',
  CREATE_USER: 'manageUser/createUser',
  CREATE_USER_PERMISSIONS: 'manageUser/createUserPermissions',
  GET_SCHOOLS: 'school/getSchoolList',
  GET_STATUS: 'school/getStatus',
  GET_STATUS_LIST: 'school/getStatusList',
  CHANGE_PASSWORD: 'auth/userChangePwd',
  UPDATE_PASSWORD: 'auth/updatePwd',
  ACCEPT_TERMS: 'auth/acceptTerms',
  GET_TIME_OUT: 'auth/getTimeOut',
  PUT_FILE: 'fileUpload/putfile',
  GET_FILE: 'fileUpload/getfile',
  DELETE_FILE: 'fileUpload/deletefile',
  LOCK_USER: 'auth/lockUser',
  UPDATE_SCHOOL_BATCH_TYPE: 'school/updateSchoolBatchType',
  GET_SCHOOL_DEMOGRAPHIC: 'school/getSchoolDemograhic',
  CREATE_NEW_SCHOOL: 'school/createNewSchool',
  GET_PERMISSIONS_LIST: 'manageUser/getPermissionList',
  GET_PDF_REPORT: 'reporting/getPDFReport'
};

export const MAX_FILE_SIZE = 104857600;

export const DEFAULT_RESULTS_PER_PAGE = 10;

export const SUPERUSER_PERMISSION_ID = 1;

export const ACCEPTED_FILE_TYPES = {
  legacy: [
    'text/plain',
  ],
  template: [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv'
  ]
}

export const GENERAL_API_ERROR = 'GENERAL_API_ERROR';

export const RESET_PASSWORD_TOKEN_EXPIRE_ERROR = 'INVALID_NO_TOKEN_DATE';

export const MUST_ACCEPT_TERMS_ERROR = 'INVALID_MUST_ACCEPT_TERMS_ERROR';

export const PROGRAM_ASSOCIATION_LABEL = <>Program Association<br /><span className='program-association-if-applicable'>(If Applicable)</span></>;

export const PASSWORD_REQUIREMENTS = <>
  <div className='reset-password-subtitle'>
    <span>Password must contain the following: </span>
    <ul className='reset-password-criteria'>
      <li>Minimum 8 characters.</li>
      <li>At least one uppercase and one lowercase letter.</li>
      <li>At least one number.</li>
    </ul>
  </div>
</>

export const SESSION_LOGOUT_SECONDS = 1800; //1800
export const SESSION_WARN_SECONDS = 500;
export const SESSION_POLL_SECONDS = 1080;

export const CREATE_USER_UC_OBJECT = {"id":0,
  "version":10,
  "accountExpired":false,
  "accountLocked":false,
  "consecutiveFailedAttempts":0,
  "enabled":true,
  "firstName":"Test",
  "invitationDeliveryDate":"",
  "lastLoginDate":"",
  "lastName":"User",
  "newUserToken":"",
  "newUserTokenDate":"",
  "passwordField":"",
  "passwordExpired":false,
  "programOther":"Other",
  "roleOther":"Other",
  "showWelcome":false,
  "username":"test35352@test.com",
  "tableauAccountCreated":true,
  "programId":1,
  "roleId":1,
  "sessionId": "",
  "sessionDate":"",
  "apiError": "",
  "loggedInUserSessionId":"",
  "loggedInUserSessionDate" :"",
  "sessionExpireDate":""
};

//This is a stub UserComposite Object used for the body of the saveUserPermissions
export const SAVE_PERMISSIONS_USER_COMPOSITE_BASE = {
  "user": {},
  "permission": {
    "id": 1,
    "version": 0,
    "authority": "ROLE_PERMISSION_SUPER_USER",
    "description": "full access",
    "name": "Super User",
    "sortLevel": 1,
    "apiError": null,
    "loggedInUserSessionId": null
  },
  "userRole": {
    "id": 0,
    "version": 0,
    "name": null,
    "sortLevel": 0,
    "apiError": null,
    "loggedInUserSessionId": null
  },
  "userPermission": {},
  "districtList": null,
  "program": {
    "id": 0,
    "version": 0,
    "name": null,
    "apiError": null,
    "loggedInUserSessionId": null
  },
  "userRoleList": [
    {
      "id": 1,
      "version": 0,
      "name": "Counselor",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 2,
      "version": 0,
      "name": "Teacher",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 3,
      "version": 0,
      "name": "School Administrator",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 4,
      "version": 0,
      "name": "District Administrator",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 5,
      "version": 0,
      "name": "Academic Prep Partner",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 6,
      "version": 0,
      "name": "Registrar",
      "sortLevel": 1,
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 7,
      "version": 0,
      "name": "Other",
      "sortLevel": 99,
      "apiError": null,
      "loggedInUserSessionId": null
    }
  ],
  "programList": [
    {
      "id": 1,
      "version": 0,
      "name": "Program 1",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 2,
      "version": 0,
      "name": "Program 2",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 3,
      "version": 0,
      "name": "Program 3",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 4,
      "version": 0,
      "name": "Program 4",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 5,
      "version": 0,
      "name": "Program 5",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 6,
      "version": 0,
      "name": "Program 6",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 7,
      "version": 0,
      "name": "Program 7",
      "apiError": null,
      "loggedInUserSessionId": null
    },
    {
      "id": 8,
      "version": 0,
      "name": "Other",
      "apiError": null,
      "loggedInUserSessionId": null
    }
  ],
  "apiError": null,
  "loggedInUserSessionId": null,
  "schoolList": null
}

export const USER_PERMISSION_LEVELS = {
  'Super User': 1,
  'Administrator': 2,
  'Account Manager': 3,
  'Batch User': 6,
  'Report Viewer': 4
}

export const USER_ACCESS_PERMISSIONS = {
  ROLE_PERMISSION_ADMIN: [
    '/my-data',
    '/upload-data',
    'download-data',
    'delete-data',
    '/reports-gallery',
    '/error-report',
    'batch-reports',
    '/switch-districts',
    'school-change-batch-type',
    'school-profile',
  ],
  ROLE_PERMISSION_COORDINATOR: [
    '/my-data',
    '/upload-data',
    'download-data',
    'delete-data',
    '/reports-gallery',
    '/error-report',
    '/switch-districts'
  ],
  ROLE_PERMISSION_BATCH: [
    '/reports-gallery',
    'batch-reports',
    '/switch-districts'
  ],
  ROLE_PERMISSION_VIEWER: [
    '/reports-gallery',
    '/switch-districts'
  ]
}

export const TERMS_VERSION = '2/10/2015';

export const TERMS_AND_CONDITIONS = <>
  <div align="left">
    <h2>The Family Educational Rights and Privacy Act (FERPA)</h2>
    <p>This Statement of Rights and Responsibilities derives from and is intended to be consistent with the Family Educational Rights and Privacy Act (FERPA) (20 U.S.C. § 1232g; 34 CFR Part 99), as well as California Education Code Section 49062 et seq. FERPA is a federal law that protects the privacy of student education records. FERPA applies to all K-12 schools and institutions of higher education that receive funds under an applicable program of the U.S. Department of Education. The California Education Code applies to K-12 schools in California, and similarly protects the privacy of student education records.</p>
    <p>FERPA Part 99.31 allows schools to share data collected for this service provided by the University, without prior consent, when the following conditions apply:</p>
    <p>(6)(i) The disclosure is to organizations conducting studies for, or on behalf of, educational agencies or institutions to:</p>
    <ol className="tos-list" type="A">
      <li>Develop, validate, or administer predictive tests;</li>
      <li>Administer student aid programs; or</li>
      <li>Improve instruction.</li>
    </ol>
    <p>The California Education Code permits disclosures for research purposes under the same circumstances. (California Education Code Section 49076 (a)(2)(E)).</p>

    <br />
      <h2>Terms of Service Agreement</h2>

      <h3>1. Acknowledgement and consent</h3>
      <p>As the representative authorized to procure services for your educational institution(s), you are agreeing to receive no less than one calendar year of services as described by the University of California in the Statement of Work (“SOW”), a separate document signed by the authorized party for the school and the University. The date of services shall be marked by either a signed document or electronic request and acknowledgement for services. By acknowledging your approved request to receive services, you are aware that the University accepts the personal demographic, academic, and identifiable data necessary to conduct the evaluation by the University of California’s Transcript Evaluation Service (“TES”)<sup>1</sup>. The University evaluates data as a service for participating public schools within California to determine student progress toward meeting the minimum admission requirements of California’s public systems of higher education. Schools are permitted to use data provided by the University to institute and assess new and innovative practices to ensure more students are on track to satisfy the “a-g” requirements. The data from TES are used to provide schools and districts with support from University programs, research and public service mission–focused partners.</p>

      <h3>2. The purpose of TES data collection, evaluation and outcomes reports</h3>
      <p>University access to records of research is critical for policy analysis and oversight purposes. Examples of how the University may use such records include, but are not limited to, responding to audits, establishing that past use of University or research sponsor funds was appropriate, responding to government demands or subpoenas, defending research findings, and facilitating research misconduct proceedings.</p>
      <p>The collection and generation of data and tangible research materials are integral parts of any research project. Accurate and appropriately recorded research data, and the creation and retention of tangible research materials, enable scholars to report, replicate and refute research findings, which ultimately advances the research enterprise. As per this document, the evaluation results produced through TES are defined as research data, and the outputs of the service, including reports or other tangible items, including the outcomes of such data, are considered research data and materials. At the subscriber’s request, the University is prepared to furnish the basic guidelines taken to ensure that Research Data, as defined below, are appropriately documented, maintained, retained for a reasonable time and accessible to the University for review and use.</p>
      <ol className="tos-list" type="a">
        <li>“Research Data” are recorded information reflecting original observations and methods related to a research study, and documentation of such data needed to reconstruct and evaluate reported results of the study, regardless of the form or medium on which it may be recorded, that is produced: (i) within a University researcher’s course and scope of employment; (ii) using University research facilities or other research resources; or (iii) using funds provided by or through the University. Such data include, but are not limited to, computer software, databases and data of a scientific or technical nature, such as laboratory notebooks, field notes, electronic storage media, and printouts. Research Data also include Tangible Research Material, as defined below. Research Data do not include administrative records incidental to award administration such as financial records, contract and grant records, etc. While such administrative records generated by University researchers are not included in the definition of Research Data under these Guidelines, they are the property of the University and may be subject to terms and conditions of individual sponsored projects, federal and state regulations, and University retention and disposition requirements.<sup>2</sup></li>
        <li>“Tangible Research Material” is a tangible item produced or collected in the course of research: (i) within a University researcher’s course and scope of employment; (ii) using University research facilities or other research resources; or (iii) using funds provided by or through the University.</li>
        <li>The University may use data collected from schools to populate the admissions application for the University and its public higher education segment partners, the California State University and California Community Colleges.<sup>3</sup> Students will have the option to opt in to this automatic population process prior to their data being populated into their in-process application.</li>
      </ol>

      <h3>3. Data Retention</h3>
      <p>As a research agent of the state, the University retains information collected and TES outcomes to support research and evaluation to identify trends in student academic performance. Both the University and other local education agencies have responsibilities concerning access to, use of and maintenance of student data used as research data and research materials. These obligations are not new and are not unique to the University; they arise from express provisions in awards and agreements with federal and other research sponsors, overarching regulatory requirements relating to funded research and fundamental precepts of research integrity.</p>
      <p>In general, principal investigators should retain all Research Data for as long as possible, but not less than a minimum of six years after final reporting, publication, completion or abandonment of the project, unless a longer retention period is indicated by the funding source or other relevant agreement.<sup>4</sup></p>

      <h3>4. Ownership and Use of Research Data</h3>
      <p>Research Data are the property of University of California Office of the President.<sup>5</sup> Any research principal investigator, or authorized entity in contract with the University to conduct such research or programs, shall retain original Research Data on behalf of the University. The principal investigator is responsible for ensuring that Research Data, whether generated by the principal investigator or the principal investigator’s research team, are recorded, stored and used in accordance with the generally accepted standards of his or her respective discipline and any requirements of applicable federal or state law or regulations, University policies and guidelines, and University contractual commitments.<sup>6</sup> The principal investigator should consult the appropriate campus or University administrative office regarding the use and stewardship of Research Data that may be subject to applicable export control regulations, laws and regulations protecting the rights and privacy of human subjects, including, but not limited to, the Health Insurance Portability and Accountability Act of 1996 (HIPAA) or other applicable laws and regulations.</p>
      <p>Data in its raw form, prior to being uploaded into the University’s TES file loader or having been queried or altered by the University’s systems or intellectual property, are the property of the school or district, as defined by their local policies. Once data has been accepted into a TES file transfer format and verified for submission to evaluate the file and its data contents, such data will become the property of the University and will be subject to the following conditions: </p>
      <ol className="tos-list" type="a">
        <li>The user will use the student TES evaluation results, provided by the University, only to support and conduct administrative activities, academic advising and counseling, and other intervention strategies intended to improve student a. progress toward satisfying minimum admission requirements for the California State University (CSU) and University of California systems of higher education.</li>
        <li>The data derived from the TES evaluations shall not be used for any purposes that generate revenue from the user or any other party without the express written consent of the University of California.</li>
      </ol>

      <h3>5. Data Sharing</h3>
      <p>The University of California supports the sharing of Research Data to advance public knowledge. In the interest of advancing knowledge, the University expects principal investigators to release and share final Research Data, particularly that which is described in a publication, for use by other investigators and researchers in a timely manner, consistent with the practices of the discipline involved. Further, such release and sharing shall be in accordance with existing University policies and guidelines, including those related to intellectual property, sponsor requirements, and applicable laws and regulations, such as laws relating to protecting the rights and privacy of human subjects. The National Institutes of Health policies on data sharing and sharing of biomedical research resources (<a href="http://grants.nih.gov/grants/policy/data_sharing/" target="_blank">http://grants.nih.gov/grants/policy/data_sharing/</a>) and the National Science Foundation <i>Policy on Dissemination and Sharing of Research Results</i> (<a href="http://www.nsf.gov/bfa/dias/policy/dmp.jsp" target="_blank">http://www.nsf.gov/bfa/dias/policy/dmp.jsp</a>) are models that investigators may find useful when planning for the sharing of Research Data. In all instances, principal investigators should consult relevant award and/or agreement terms to determine whether Research Data are subject to any special handling, use or restriction terms.</p>

      <h3>6. Subscriber Responsibilities and Rights</h3>
      <p>By subscribing to this service and providing authorized access to your designee and those further provided access based on your or designees’ discretion, you agree to hold the data in strict confidence. The user agrees NOT to release data to any other unauthorized person or organization.</p>
      <p>The user shall retain data furnished by the school/district and the University in a place physically secure from access by unauthorized persons. Data in electronic format – including, but not limited to, hard drives, CDs or diskettes – shall be stored and processed in such a way that unauthorized persons cannot retrieve the data by means of computer, remote terminal or other means. The user agrees that any computer on which the data reside will be password-protected at all times.</p>
      <p>No individual, school and/or district shall be identifiable in any reports, publications or other documents that are created by the user with the use of the data, unless at the specific request of the individual(s) authorized to make a request of this report, which must accompany a signed and notarized letter acknowledging such a request. Results for groups of individuals, schools and/or districts will only be reported when the number (i.e., the “cell size”) is ten (10) or greater and in such a manner that results for groups of less than ten (10) cannot be easily calculated from other reported data.</p>
      <p>The user shall adhere to all federal, state and local statutes, regulations and other requirements pertaining to the security, confidentiality and privacy of data including, but not limited to, the Family Educational Rights and Privacy Act (FERPA) (20 U.S.C. § 1232g; 34 CFR Part 99).</p>

      <h3>7. Fees and Payment </h3>
      <p>Certain services carry subscription fees (“Subscription Fees”). Subscription Fees will be due on an annual basis (the “Subscription Term”). Before the beginning of each Subscription Term during the term of this Agreement, the University will invoice you (or, if you’ve provided a credit card number through Account Administration, will bill that credit card) for the applicable Subscription Fees due for the following Subscription Term. Invoices for Subscription Fees must be paid by the beginning of the Subscription Term or within thirty (30) days after your receipt thereof, whichever is later. Any special arrangements regarding payment will be reflected in a Statement of Work or similar document.</p>
      <p>Unless otherwise agreed by you and the University in writing, all fees are non-refundable, including without limitation if this Agreement terminates prior to the end of a Subscription Term for which you have pre-paid Subscription Fees. All amounts due hereunder shall be paid in United States dollars within the United States. Conversion of foreign currency to United States dollars shall be made at the conversion rate existing in the United States (as reported in the Wall Street Journal) on the first working day of the calendar month during which the applicable payment is due. </p>
      <p>If the payment information you have provided is incorrect or incomplete, or if you are late paying any invoice or the University is otherwise unable to complete a transaction or collect timely payment due to your error or omission, any payment due hereunder that is so delayed shall bear interest at the rate of one percent (1%) per month or the highest rate allowed by applicable law, whichever is less.</p>

      <h3>8. Term and Termination; Suspension</h3>
      <p>This Agreement shall remain in full force and effect so long as you use the service in strict accordance with the terms, conditions and limitations of this Agreement. Either party may terminate this Agreement for any reason or for no reason upon written notice to the other party (email is sufficient). The University may suspend your access to the services and the performance of any services at any time and without notice if the University reasonably believes in its sole discretion that you have breached any of the terms of this Agreement. If the University terminates this Agreement (except in the event of a breach of the Agreement by you), we will refund to you a prorated portion of your fees based on the date of termination.</p>
      <p>Upon termination of this Agreement, your right to use and/or access the services directly related to TES shall terminate, and the University will cease performance of any of these services. The following provisions shall survive termination of this Agreement: Notwithstanding the foregoing, after termination of this Agreement, you may continue to use TES reports that you have downloaded prior to the effective date of termination, solely in accordance with all restrictions herein. </p>

      <h3>9. Warranties; Warranty Disclaimer</h3>
      <p>The Family Educational Rights and Privacy Act (“FERPA”) and California Education Code Section 49076(a)(1)(A) both generally require that schools get prior written consent from a parent or guardian of a minor student before disclosing any educational records regarding such student (“Educational Records”) to third parties. However, education records can be shared with school officials who have a legitimate educational interest. If you are a School, you hereby agree to designate the University (including its employees, contractors and agents) as an “other school official,” under FERPA and/or the California Education Code, who has a “legitimate educational interest” in using and accessing such Educational Records. Further, you hereby represent and warrant that (a) you have obtained all consents necessary in connection with disclosing any Educational Records directly or indirectly to the University, Users or otherwise in connection with the Services, and (b) your disclosures described in (a) are not and will not be a violation of FERPA.</p>
      <p>The University hereby represents and warrants that (a) it will perform the services in a professional and workmanlike manner, and (b) it will use the Educational Records only in accordance with the terms of this Agreement.</p>
      <p>Except as expressly set forth in the agreement, the services, reports and anything provided in connection with this agreement are provided “as-is,” without any warranties of any kind. The University hereby disclaims all warranties, express or implied, relating to the subject matter hereunder, including without limitation all implied warranties of merchantability, fitness for a particular purpose title and non-infringement.</p>

      <h3>10. Limitation of Liability </h3>
      <p>IN NO EVENT WILL THE UNIVERSITY (OR ITS LICENSORS OR SUPPLIERS) BE LIABLE FOR</p>
      <ol className="tos-list" type="a">
        <li>ANY INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF THE SERVICES, PERFORMANCE OF THE SERVICES OR ANYTHING PROVIDED IN CONNECTION WITH THIS AGREEMENT,</li>
        <li>THE DELAY OR INABILITY TO USE THE SERVICES OR ANYTHING PROVIDED IN CONNECTION WITH THIS AGREEMENT OR OTHERWISE ARISING FROM THIS AGREEMENT, INCLUDING WITHOUT LIMITATION LOSS OR CORRUPTION OF DATA, ERROR OR OMISSION IN THE SERVICES, LOSS OF REVENUE OR ANTICIPATED PROFITS OR LOST BUSINESS OR LOST SALES, AND</li>
        <li>ANY MATTER BEYOND ITS OR THEIR REASONABLE CONTROL, AND ITS OBLIGATIONS HEREUNDER SHALL BE LIMITED TO THE EXERCISE OF COMMERCIALLY REASONABLE EFFORTS; IN EACH CASE, WHETHER BASED IN CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHERWISE, EVEN IF THE UNIVERSITY HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES.</li>
      </ol>
      <br /><br />
        <p>
          Please note that if you are uploading transcripts to TES exclusively as part of the State Eligibility Study, the preceding Terms of Service do not apply. Select “I agree” to proceed through the system.
        </p>
        <br /><br />
          <ol className="tos-list tos-footer">
            <li>See the list of data collected for the TES evaluation system for each data system and manual upload tool.</li>
            <li>Other research data may be obtained through material transfer agreements, license agreements or other means. Such other research data that are not produced or collected by the University may be subject to third-party provider obligations, and should be handled in accordance with contractual commitments.</li>
            <li>Select the application name for the URL to access list of data elements: <a href="https://admissions.universityofcalifornia.edu/applicant/html/terms_of_use.html" target="_blank">applyUC</a>, <a href="https://secure.csumentor.edu/privacy.asp" target="_blank">CSUMentor</a>, and <a href="http://home.cccapply.org/privacy-policy" target="_blank">CCC apply</a>.</li>
            <li>Contract and Grant Manual, Chapter 17-310: Records Disposition Schedules for Contract and Grant Documents;&nbsp;Administrative Records Relating to Research: Retention Requirements (last updated June 2010).</li>
            <li><a href="http://www.ucop.edu/academic-personnel-programs/_files/apm/apm-020.pdf" target="_blank">University of California Regulation No. 4</a> (APM-020) provides that original records of the research are the property of the University. (“Original records” may include tangible records of research, such as biological materials, chemical compounds, plants, etc.). California Labor Code § 2860 provides that everything that an employee acquires by virtue of his/her employment (except compensation) belongs to the employer whether acquired during or after the term of employment.</li>
            <li>Contract and Grant Manual, <a href="http://www.ucop.edu/research-policy-analysis-coordination/resources-tools" target="_blank">Chapter 10-330: Principal Investigators</a>.</li>
          </ol>
  </div>
</>